/**
 * FAQ accordion — single-open, smooth height + icon motion
 */
(() => {
  const ROOT = '[data-ct-faq]';

  /** @param {HTMLElement} root */
  const init = (root) => {
    if (root.dataset.ctFaqReady === 'true') return;
    root.dataset.ctFaqReady = 'true';

    const items = /** @type {NodeListOf<HTMLElement>} */ (
      root.querySelectorAll('[data-ct-faq-item]')
    );
    if (!items.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /** @param {HTMLElement} item @param {boolean} open */
    const setOpen = (item, open) => {
      const trigger = item.querySelector('[data-ct-faq-trigger]');
      const panel = item.querySelector('[data-ct-faq-panel]');
      if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (reduceMotion) {
        item.classList.toggle('is-open', open);
        panel.hidden = !open;
        panel.style.height = '';
        panel.style.opacity = '';
        return;
      }

      if (open) {
        item.classList.add('is-open');
        panel.hidden = false;
        panel.style.height = '0px';
        panel.style.opacity = '0';
        panel.offsetHeight;
        panel.style.height = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';

        const onEnd = (event) => {
          if (event.target !== panel || event.propertyName !== 'height') return;
          if (!item.classList.contains('is-open')) return;
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', onEnd);
        };
        panel.addEventListener('transitionend', onEnd);
        return;
      }

      // Close: lock current height first, then animate to 0 — never hide mid-transition
      const currentHeight = panel.scrollHeight;
      panel.style.height = `${currentHeight}px`;
      panel.style.opacity = '1';
      panel.offsetHeight;
      item.classList.remove('is-open');
      panel.style.height = '0px';
      panel.style.opacity = '0';

      const onCloseEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return;
        if (item.classList.contains('is-open')) return;
        panel.hidden = true;
        panel.removeEventListener('transitionend', onCloseEnd);
      };
      panel.addEventListener('transitionend', onCloseEnd);
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-ct-faq-trigger]');
      const panel = item.querySelector('[data-ct-faq-panel]');
      if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

      const initiallyOpen = item.classList.contains('is-open');
      panel.hidden = !initiallyOpen;
      panel.style.height = initiallyOpen ? 'auto' : '0px';
      panel.style.opacity = initiallyOpen ? '1' : '0';
      trigger.setAttribute('aria-expanded', initiallyOpen ? 'true' : 'false');

      trigger.addEventListener('click', () => {
        const willOpen = !item.classList.contains('is-open');
        items.forEach((other) => {
          if (other !== item && other.classList.contains('is-open')) setOpen(other, false);
        });
        setOpen(item, willOpen);
      });
    });
  };

  const boot = () => {
    document.querySelectorAll(ROOT).forEach((el) => {
      if (el instanceof HTMLElement) init(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll(ROOT).forEach((el) => {
      if (el instanceof HTMLElement) delete el.dataset.ctFaqReady;
    });
    boot();
  });
})();
